import React from 'react';
import { Modal } from 'react-bootstrap';

interface ModalComponentProps {
  show: boolean;
  title: string;
  body: React.ReactNode;
  onClose?: () => void;
  onSubmit?: () => void;
  submitText?: string;
  closeText?: string;
  size?:any
}

const ModalComponent: React.FC<ModalComponentProps> = ({
  show,
  title,
  body,
  onClose,
  size
}) => {
  return (
    <Modal show={show} onHide={onClose} centered size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
    </Modal>
  );
};

export default ModalComponent;
